import { render } from "./PornHubIcon.vue?vue&type=template&id=15553df3&scoped=true"
import script from "./PornHubIcon.vue?vue&type=script&lang=js"
export * from "./PornHubIcon.vue?vue&type=script&lang=js"

import "./PornHubIcon.vue?vue&type=style&index=0&id=15553df3&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15553df3"]])

export default __exports__